import { inject, Injectable } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { environment } from '../../../environments/environment';

export type FeatureFlags = typeof environment.featureFlags;

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  public readonly flags: FeatureFlags = environment.featureFlags;
}

export const featureFlagCanMatch =
  (flag: keyof FeatureFlags): CanMatchFn =>
  () =>
    inject(FeatureFlagService).flags[flag];
